{
  "groups": {
    "boundariesSlots": "Boundaries / Slots",
    "controls": "Controls",
    "general": "General",
    "monitoring": "Monitoring",
    "speedFlow": "Speed / Flow"
  },
  "linkedDevice": {
    "deviceAlias": "Device Alias"
  },
  "stopDetection": {
    "description": "Sends you a text message when this pivot is detected applying water without moving — staying inside the minimum distance radius for the full time window.",
    "label": "Stop Detection (GPS)",
    "minimumDistance": "Minimum Distance",
    "timeWindow": "Time Window",
    "wheelDescription": "Sends you a text message when the linked monitor's wheel sensor detects this pivot has stopped moving.",
    "wheelLabel": "Stop Detection (Wheel)",
    "wheelUpdateFailed": "Failed to update the wheel stop notification. Please try again."
  }
}
